
interface GtmEvent {
   event: string; // Accept string for custom events
  [key: string]: any; // Accept Any Custom Params
}

/**
 * @param eventData The structured event object to push.
 */
export const pushEcomGTMEvent = (eventData: GtmEvent) => {
  if (globalThis.dataLayer === 'undefined') {
    console.error('GTM dataLayer is not available.');
    return;
  }

  globalThis.dataLayer.push(eventData);
};
